<template>
  <div>
    <div class="d-flex align-items-center mb-3">
      <div>
        <h1 class="page-header mb-0"><i class="fas fa-lock"></i> Lakatok</h1>
      </div>
      <div class="ms-auto">
        <button
          v-if="user.role_id == 1"
          class="btn btn-success btn-rounded px-4 rounded-pill"
          v-b-modal.addLockModal
        >
          <i class="fa fa-plus fa-lg me-2 ms-n2 text-success-900"></i> Új lakat
        </button>
      </div>
    </div>
    <b-modal
      id="addLockModal"
      cancel-variant="default"
      @cancel="closeAddModal()"
      @ok="addLock"
      ok-title="Létrehozás"
      cancel-title="Mégse"
      :ok-disabled="loading"
      @shown="$refs.add_lock_modal_name_input.focus()"
    >
      <template slot="modal-header">
        <h4 class="modal-title">Új lakat</h4>
        <a class="btn-close" @click="closeAddModal()"></a>
      </template>
      <Loading v-if="lock_colors === false" title="Opciók betöltése"></Loading>
      <form
        @submit.prevent="addLock()"
        ref="lock_modal_form"
        v-else-if="loading == false"
      >
        <div class="form-group">
          <label class="form-label">Megnevezés:</label>
          <input
            ref="add_lock_modal_name_input"
            class="form-control text-center"
            type="text"
            v-model="lock.name"
            required
            :class="{ 'is-invalid': errors.name }"
          />
          <div class="invalid-feedback d-block" v-if="errors.name">
            {{ errors.name[0] }}
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-12">
            <label class="form-label">Szín:</label>
          </div>
          <div
            v-for="(color, id) in lock_colors"
            :key="id"
            class="col-3 text-center"
          >
            <button
              type="button"
              @click="setLockColor(color.id)"
              :data-bs-title="color.name"
              class="btn btn-icon"
              :class="[
                color.bg_c_class,
                { 'border border-warning border-3': lock.color == color.id },
              ]"
            ></button>
          </div>
          <div class="invalid-feedback d-block" v-if="errors.color">
            {{ errors.color[0] }}
          </div>
        </div>
        <div class="form-group mt-2" v-if="lock.color == 2">
          <label class="form-label">Csoport lakat szekrény:</label>
          <input type="text" class="form-control" />
        </div>
        <button type="submit" class="d-none"></button>
      </form>
      <Loading v-if="loading == true" title="Létrehozás"></Loading>
    </b-modal>
    <panel title="Lakatok">
      <Loading v-if="locks === false" title="Lakatok betöltése"></Loading>
      <NoRecords
        v-if="locks.length == 0"
        main_icon="fa fa-lock"
        value="false"
        title="Nincsenek lakatok"
        subtitle="hozzon létre újat"
      ></NoRecords>
      <vue-good-table
        v-if="locks.length != 0 && locks !== false"
        :columns="columns"
        :rows="locks"
        :lineNumbers="true"
        :search-options="{ enabled: false, placeholder: 'Keresés...' }"
        :pagination-options="{
          enabled: true,
          position: 'bottom',
          firstLabel: 'Első Lap',
          lastLabel: 'Utolsó Lap',
          nextLabel: 'következő',
          prevLabel: 'előző',
          rowsPerPageLabel: 'Sor oldalanként',
          ofLabel: '/',
          allLabel: 'Összes',
          infoFn: (params) => `első sorszám: ${params.firstRecordOnPage}`,
        }"
      >
        <template slot="table-row" slot-scope="props">
          <span v-if="props.column.field == 'actions'">
            <button
              v-if="user.role_id == 1"
              @click="deleteLock(props.row.id)"
              class="btn btn-danger mx-1"
              title="törlés"
            >
              <i class="fa fa-trash"></i>
            </button>
          </span>
          <span v-else-if="props.column.field == 'color'">
            <button
              type="button"
              :data-bs-title="
                lock_colors[
                  lock_colors.map((color) => color.id).indexOf(props.row.color)
                ].name
              "
              class="btn btn-icon"
              :class="
                lock_colors[
                  lock_colors.map((color) => color.id).indexOf(props.row.color)
                ].bg_c_class
              "
            ></button>
          </span>
          <span v-else>
            {{ props.formattedRow[props.column.field] }}
          </span>
        </template>
      </vue-good-table>
    </panel>
  </div>
</template>

<script>
//:class="{'col-'+Math.floor(12/lock_colors.length()) : lock_colors !== false}"
import Loading from "../../components/Loading";
import NoRecords from "../../components/NoRecords";
import Lock from "../../apis/Lock";
import Box from "../../apis/Box";
/*import Config from "../../apis/Config"; */
import Confirmation from "../../apis/Confirmation";

export default {
  components: {
    Loading,
    NoRecords,
  },
  data() {
    return {
      columns: [
        {
          label: "Megnevezés",
          field: "name",
          filterOptions: {
            enabled: true,
            placeholder: "Keresés a nevek között",
            filterFn: this.nameFilter,
          },
          sortFn: this.sortFn,
        },
        {
          label: "Szín",
          field: "color",
          filterOptions: {
            filterDropdownItems: JSON.parse(
              localStorage.getItem("constants")
            ).lock_colors.map((c) => ({
              value: c.id,
              text: c.name,
            })),
            placeholder: "Összes szín",
            enabled: true,
          },
          thClass: "text-dark",
        },
        {
          label: "Műveletek",
          field: "actions",
          width: "15%",
          sortable: false,
          thClass: "text-end",
          tdClass: "text-end",
        },
      ],
      locks: false,
      boxes: false,
      lock_colors: false,
      lock: {},
      errors: [],
      loading: false,
    };
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
  },
  created() {
    /*Config.getConstant('lock_colors')
			.then(response => {
				this.lock_colors = JSON.parse(JSON.stringify(response.data));
			});*/
    this.lock_colors = JSON.parse(
      localStorage.getItem("constants")
    ).lock_colors;
    Lock.index().then((response) => {
      this.locks = response.data;
    });
    Box.index().then((response) => {
      this.boxes = response.data;
    });
  },
  methods: {
    sortFn(x, y) {
      return parseInt(x) < parseInt(y) ? -1 : parseInt(x) > parseInt(y) ? 1 : 0;
    },
    nameFilter(data, filter) {
      return data == filter;
    },
    closeAddModal() {
      this.lock = {};
      this.errors = [];
      this.$bvModal.hide("addLockModal");
    },
    setLockColor(id) {
      if (id != 2) {
        this.lock.box_id = null;
      }
      this.$set(this.lock, "color", id);
    },
    addLock(bvModalEvt) {
      this.loading = true;
      if (bvModalEvt) {
        //ok gombra van csak event
        bvModalEvt.preventDefault();
      }
      if (!this.lock.name) {
        this.errors = [];
        this.$set(this.errors, "name", ["Név megadása kötelező!"]);
        this.loading = false;
      } else if (!this.lock.color) {
        this.errors = [];
        this.$set(this.errors, "color", ["Válasszon színt!"]);
        this.loading = false;
      } else {
        this.errors = [];
        Lock.add(this.lock)
          .then((response) => {
            this.locks.unshift(response.data);
            this.closeAddModal();
          })
          .catch((error) => {
            if (error.response.data.errors) {
              this.errors = error.response.data.errors;
            }
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    deleteLock(id) {
      Confirmation.swalDelete().then((response) => {
        if (response.isConfirmed === true) {
          Lock.delete(id)
            .then(() => {
              this.locks.splice(
                this.locks.map((lock) => lock.id).indexOf(id),
                1
              );
            })
            .catch((error) => {
              console.log(error);
            });
        }
      });
    },
  },
};
</script>

<style></style>
